<script lang="ts">
	import type { Toast } from "@components/Toast.js";
	import Icon from "@components/common/Icon.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import plus from "@core/assets/icons/plus.svg?raw";
	import translations from "./Toast.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";

	const translate = getTranslate(translations);

	const { toast }: { toast: Toast } = $props();
	const { description, title, close, icon, id, ...rest } = $derived(toast);
</script>

<output
	class="flex w-full max-w-100 border-fcrlightgray-300 border justify-between rounded-3xl p-6 bg-white shadow-md"
	{id}
>
	<svelte:element this={rest.onclick ? "button" : "div"} class="flex gap-4 items-center" {...rest}>
		<Icon {icon} class="size-6 text-fcrbrown" />
		<div class="flex flex-col gap-1 text-left">
			<div class="text-base/tighter font-antipol text-fcrdarkbrown">
				<Formatted text={title} />
			</div>
			{#if description}
				<div class="text-sm/tighter text-fcrgray font-medium">
					<Formatted text={description} />
				</div>
			{/if}
		</div>
	</svelte:element>
	<button type="button" aria-label={translate("close")} onclick={close}>
		<Icon icon={plus} class="size-6 text-fcrgray rotate-45" />
	</button>
</output>
